export default __webpack_public_path__ + "static/media/space-bg-mobile.609feab9.png";